export default "# ¡Bienvenido!\n\nNEED\n\nAntes de que pueda votar, por favor confirme que usted no es un robot:";